var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lot.currency)?_c('div',{staticClass:"ta-lot-actual-price"},[(_vm.lastBidAmount)?[_vm._v(" "+_vm._s(_vm._f("asCurrency")(_vm.lastBidAmount,_vm.lot.currency.code))+" ")]:[_vm._v(" ("+_vm._s(_vm.$t('Empty'))+") ")]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }